export default __webpack_public_path__ + "static/media/envelope-circle-tc.91ab37ae.svg";